<div class="form-wrapper-center-flex">
  <kendo-card [width]="'auto'">
    <kendo-card-body>
      <div>
        <form [formGroup]="loginForm" class="k-form">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend">
              {{ "LOGIN_FORM.TITLE" | translate }}
            </legend>

            <kendo-formfield>
              <kendo-label
                [for]="email"
                [text]="'LOGIN_FORM.EMAIL' | translate"
              ></kendo-label>
              <input formControlName="Email" #email kendoTextBox />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label
                [for]="password"
                [text]="'LOGIN_FORM.PASSWORD' | translate"
              ></kendo-label>
              <input
                formControlName="Password"
                #password
                kendoTextBox
                type="password"
              />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label text="Language"></kendo-label>
              <kendo-dropdownlist
                [data]="languageSelect"
                formControlName="Language"
              >
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                  <!-- TODO: Add country flag icons -->
                  {{ "LANGUAGES." + dataItem | translate }}
                </ng-template>
                <ng-template kendoDropDownListValueTemplate let-dataItem>
                  <span *ngIf="dataItem">{{
                    "LANGUAGES." + dataItem | translate
                  }}</span>
                </ng-template>
              </kendo-dropdownlist>
            </kendo-formfield>

            <div class="recaptcha-wrapper">
              <re-captcha formControlName="Recaptcha"></re-captcha>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="additional-actions">
        <button
          themeColor="primary"
          routerLink="/auth/forgot-password"
          kendoButton
          fillMode="link"
        >
          {{ "LOGIN_FORM.FORGOT_PASSWORD" | translate }}
        </button>
        <button
          themeColor="primary"
          routerLink="/auth/register"
          kendoButton
          fillMode="link"
        >
          {{ "LOGIN_FORM.REGISTER_REDIRECT" | translate }}
        </button>
      </div>
    </kendo-card-body>
    <hr kendoCardSeparator />
    <kendo-card-actions layout="end">
      <button
        themeColor="primary"
        [disabled]="loginForm.invalid"
        kendoButton
        fillMode="flat"
        (click)="submit()"
        >
        {{ "LOGIN_FORM.SUBMIT" | translate }}
      </button>
    </kendo-card-actions>
  </kendo-card>
</div>
